const API_ROOT = '/api/v1';
export const AUDIENCE_LIST = `${API_ROOT}/audiences`;
export const AUDIENCE_GET_ACTIVITY_DETIALS = (id) => `${API_ROOT}/audiences/${id}/get_activity_details`;
export const AUDIENCE_GET_RESPONSE_DETIALS = (id) => `${API_ROOT}/audiences/${id}/get_responses`;
export const AUDIENCE_GET_ANSWERS = (id) => `${API_ROOT}/audiences/${id}/answers`;
export const AUDIENCE_GET_FILES_DETAILS = (id) => `${API_ROOT}/audiences/${id}/get_files`;
export const AUDIENCE_SEND_PATH_NUDGE = (id, learningMaterialId) => `${API_ROOT}/audiences/${id}/paths/${learningMaterialId}/nudge`;
export const AUDIENCE_SHOW = (id) => `${API_ROOT}/audiences/${id}`;
export const AUDIENCE_UPDATE_NOTES = (id) => `${API_ROOT}/audiences/${id}/private_notes`;
